module.exports = __webpack_public_path__ + "static/assets/img/pipe2.37ad3c0d.svg";